import './ItemCategoryList.scss';

import { Component } from '../../components/Component';
import { FiSubHeaderService } from './../../components/FiSubHeader/FiSubHeaderService';
import * as angular from 'angular';
import { IFurnitureItem, FiFurnitureService } from '../../components/fiFurniture/FiFurnitureService';
// import { FiFilterService } from '../../components/fiFilter/FiFilterService';
import { FiCart } from '../../services/Cart';
import * as uirouter from 'angular-ui-router';

@Component({
    controllerAs: 'vm',
    template: require('./ItemCategoryList.html'),
    bindings: {
    }
})
export class ItemCategoryList {
    static $inject = [
        '$http',
        'fiSubHeaderService',
        '$window',
        'fiFurnitureService',
        'fiCart',
        '$mdSidenav',
        '$state',
        '$location',
        '$scope',
    ];


    constructor(
        private $http: angular.IHttpService,
        private fshs: FiSubHeaderService,
        private $window: angular.IWindowService,
        private fs: FiFurnitureService,
        private cart: FiCart,
        private $mdSidenav: angular.material.ISidenavService,
        private $state: uirouter.StateService,
        private $location: angular.ILocationService,
        private $scope: angular.IScope,
    ) {
        
    }

    data = [];
    type: number;
    title: string;
    items: IFurnitureItem[];

    

    $onInit() {

        this.$http.get('https://www.fitit.lt/db/items.php').then((data) => {
            this.data.push(data);

            // console.log(this.data)
        });


        var url = this.$location.path().split('/');
        if (url[2] == 'spintos-varstomomis-durimis') {
            this.type = 1;
            this.title = 'Spintos varstomomis durimis';
        }
        else if (url[2] == 'spintos-stumdomomis-durimis') {
            this.type = 2;
            this.title = 'Spintos stumdomomis durimis';
        }
        else if (url[2] == 'komodos') {
            this.type = 3;
            this.title = 'Komodos';
        }
        else if (url[2] == 'lentynos') {
            this.type = 4;
            this.title = 'Lentynos';
        }
        else if (url[2] == 'tv-spinteles') {
            this.type = 5;
            this.title = 'TV spintelės';
        }
        else if (url[2] == 'spinteles') {
            this.type = 6;
            this.title = 'Spintelės';
        }
        

    }

   
}
